module.exports = __webpack_public_path__ + "static/media/bwt.e26d0ba1.png";